import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'

import EditorViewer from '@/_components/editorJS/viewer/viewer.vue'
import Attachment from '@/_components/image/attachment.vue'

import Log from '@/views/Log/models/log'
import HSEDocument from '@/views/Project/HSE/models/hseDocument'
import LogProject from '@/views/Project/Project/components/logProject/logProject.vue'
import uniqBy from 'lodash/uniqBy'
@Component({
    inheritAttrs: false,
    name: 'HSEDocumentInfo',
    components: { DialogTemplate, EditorViewer, Attachment, LogProject },
})
export default class HSEDocumentInfo extends Mixins<MixinInterface>() {
    @Prop() props!: any

    // INFINITELOADING can only be added when view is mounted
    logs: Array<Log> = []
    timeStamp: string | null = new Date().toISOString()
    loading = false
    downloadByUsers: { name: string; time: string }[] = []
    tabView = 'history' as 'history' | 'download-history'

    isMounted = false
    mounted() {
        this.isMounted = true
    }

    get HSEDocument(): HSEDocument {
        return this.props.document
    }

    async getLogs($state: any) {
        if (!this.timeStamp) {
            this.timeStamp = new Date().toISOString()
        }
        if (this.currentProjectId) {
            let res: Array<Log> = await this.HSEDocument.getLog(
                this.currentProjectId,
                this.timeStamp
            ).catch((error) => {
                console.error('getAuthorizationLog error', error)
                $state.complete()
            })

            this.logs.push(...res)
            this.logs = uniqBy(this.logs, '_id')

            if (res.length == Log.limit) {
                let lastElement = res?.pop()
                this.timeStamp = lastElement ? lastElement?.['time'] : null
                $state.loaded()
            } else {
                this.timeStamp = null
                if (this.logs.length > 0) {
                    $state.loaded()
                }
                $state.complete()
            }
        }
    }

    async getDownloadLogs($state: any) {
        if (!this.timeStamp) {
            this.timeStamp = new Date().toISOString()
        }
        if (this.currentProjectId) {
            let res = await this.HSEDocument.getLog(this.currentProjectId, this.timeStamp, '2')

            this.downloadByUsers = [...res]
            if (res.length == Log.limit) {
                let lastElement = res?.pop()
                this.timeStamp = lastElement ? lastElement?.['time'] : null
                $state.loaded()
            } else {
                this.timeStamp = null
                if (this.downloadByUsers.length > 0) {
                    $state.loaded()
                }
                $state.complete()
            }
        }
    }
}
